export default __webpack_public_path__ + "static/media/pec4.11f84420.jpg";